@if (loading | async) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div *ngIf="verificationPackage" class="verification-package-detail container-fluid p-3 mb-5">
        <div class="w-fit">
            <app-back-button url="/verification-packages" component="Verification Packages"></app-back-button>
        </div>
        <div class="mt-3 d-flex justify-content-between">
            <div class="font-weight-bold">
                <h1>{{ verificationPackage.name }}</h1>
            </div>
            <div class="d-flex mt-2 me-1">
                <button mat-raised-button *ngIf="tabIndex === 0" class="action-button d-flex col-auto align-items-center"
                    (click)="onEditVerificationPackageClick()" style="margin-right:8px;">
                    <mat-icon class="button-icon">edit</mat-icon>
                    Edit Verification Package
                </button>
                <button mat-raised-button *ngIf="tabIndex === 0 && verificationPackage.status_id === 1" class="warn-button d-flex col-auto align-items-center" (click)="onUpdateVerificationPackageStatusClick()">
                    <mat-icon class="button-icon">delete</mat-icon>
                    Deactivate
                </button>
                <button mat-raised-button *ngIf="tabIndex === 0 && verificationPackage.status_id === 2" class="action-button d-flex col-auto align-items-center" style="margin-left:8px;" (click)="onUpdateVerificationPackageStatusClick()">
                    <mat-icon class="button-icon">add</mat-icon>
                    Activate
                </button>
                <button mat-raised-button *ngIf="tabIndex === 1" class="action-button d-flex col-auto align-items-center"
                (click)="onAddCheckTypeClick()">
                    <mat-icon class="button-icon">add</mat-icon>
                    Add Check Type
                </button>
            </div>
        </div>
        <mat-card class="mt-3 pb-5">
            <mat-tab-group mat-align-tabs="center" dynamicHeight animationDuration="0ms" (selectedTabChange)="tabChanged($event)" [selectedIndex]="tabIndex">
                <mat-tab label="Basic Info">
                    <div class="p-2">
                        <app-detail-info-card class="col-12" [data]="basicInfo" [fullRowData]="description" [disableShadow]="true"></app-detail-info-card>
                    </div>
                </mat-tab>
                <mat-tab label="Check Types">
                    <div class="row">
                        <div *ngIf="tableLength <= 0; else checkTypesTable">
                            <div class="row justify-content-center">
                                <div class="w-100 d-flex justify-content-center mt-5">
                                    No Check Types exist on Verification Package.
                                </div>
                            </div>
                        </div>
                        <ng-template #checkTypesTable>
                            <app-data-table
                                [dataSource]="dataSource"
                                [displayedColumns]="displayedColumns"
                                [component]="'Check Types'"
                                [displayLoadingIndicator]="loading"
                                [tableLength]="tableLength"
                                [showSearch]="false"
                                [showPaginator]="false"
                                [hidePointer]="true"
                                [navigateOnRowClick]="false"
                                (deleteVerificationCheckTypeClickedEvent)="onDeleteVerificationCheckTypeClick($event)"
                                [getStatusColor]="getCheckTypeStatusColor">
                            </app-data-table>
                        </ng-template>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card>
    </div>
}